import { Icon } from '@material-ui/core';

import SplitScreenIconImage from 'Console/assets/images/icons/SplitScreenIcon.png';

interface SplitScreenIconProps {
    className: string | undefined;
}

const SplitScreenIcon = ({ className }: SplitScreenIconProps): JSX.Element => (
    <Icon className={className}>
        <img height={16} src={SplitScreenIconImage} />
    </Icon>
);

export default SplitScreenIcon;
